<template>
  <div>
    <a-modal
      :visible.sync="visible"
      :width="'90%'"
      @cancel="visible = false"
      :maskClosable="false"
      :destroyOnClose="true"
      :title="currentMedia.title"
      onOk="handleOk"
      :footer="null"
    >
      <div v-if="videoUrl" class="video-area">
        <video
          ref="video"
          oncontextmenu="return false;"
          controlsList="nodownload noremote footbar"
          :src="videoUrl"
          controls="true"
          @canplay="handleVideoInit"
          @play="handleVideoPlay"
          @timeupdate="handleVideoUpdate"
          @pause="handleVideoPause"
          @ended="handleVideoEnded"
        ></video>
      </div>
      <div v-if="mediaContent" v-html="mediaContent" class="video-area"></div>
    </a-modal>
  </div>
</template>
<script>
// import '@/components/jeecg/JModal'
import { getAction } from "@/api/manage";
import { mixinDevice } from "@/utils/mixin.js";
import { getQiniuUrl, getQiniuFile } from "@/utils/qiniu.js";
export default {
  name: "CourseMediaViewModal",
  mixins: [mixinDevice],
  data() {
    return {
      customStyle:
        "background: #f7f7f7;border-radius: 4px;margin-bottom: 24px;border: 0;overflow: hidden",
      visible: false,
      loading: false,
      courseId: "",
      unitId: "",
      mediaId: "",
      videoUrl: "",
      mediaList: [],
      url: {
        unitMedia: "/teaching/teachingCourseUnit/unitMedia",
        studyLog: "/teaching/teachingStudyLog/study",
        unitStudyLog: "/teaching/teachingStudyLog/getUnitStudyLog",
      },
      mediaContent: "",
      currentMedia: {},
      lastPlayTime: 0, //上次视频观看进度
      cacheDuration: 0, //等待提交的进度
      logTimer: null
    };
  },
  mounted() {
    // contextmenu 禁用右键菜单
    document.addEventListener("contextmenu", function (e) {
      e.preventDefault();
    });
    // //禁止复制  selectstart
    // document.addEventListener('selectstart',function(e){
    //     e.preventDefault();
    // })
  },
  methods: {
    getQiniuUrl,
    getQiniuFile,
    handleCancel(e) {
      this.visible = false;
      this.unit = {};
      this.videoUrl = "";
      this.mediaList = [];
      clearInterval(this.logTimer)
    },
    view(courseId, unitId, mediaId) {
      this.courseId = courseId;
      this.unitId = unitId;
      this.mediaId = mediaId;
      this.getMediaInfo(mediaId);
    },
    getMediaInfo(mediaId) {
      this.loading = true;
      getAction("/teaching/teachingCourseMedia/getMediaInfo",{id: mediaId, unitId: this.unitId, courseId: this.courseId})
        .then((res) => {
          if (res.success) {
            this.currentMedia = res.result;
            this.changeMedia(this.currentMedia);
            this.getUnitStudyLog();
            this.visible = true;
          }else{
            this.$message.info(res.message)
          }
        })
        .catch((e) => {
          console.log(e);
          let data = e.response.data;
          if (data.message.includes("Token失效")) {
            this.$message.error("未登录");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeMedia(media) {
      this.currentMedia = media;
      switch (media.mediaType) {
        case 1:
          //切换视频
          this.mediaContent = "";
          this.videoUrl = media.mediaPath_url;
          break;
        case 3:
        case 5:
          this.handleViewCode(media);
          break;
        case 6:
          window.open(
            "https://view.officeapps.live.com/op/embed.aspx?src=" +
              media.mediaPath_url
          );
          break;
        case 7: //富文本
          this.videoUrl = "";
          this.mediaContent = media.mediaContent;
          this.studyLog(0, 0, true);
          break;
        case 8: //OJ
          window.open("/onlinecode/index.html?questionId=" + media.questionId);
          break;
        default:
          window.open(media.mediaPath_url);
      }
    },
    handleVideoInit() {
      console.log("video init");
      this.studyLog(0, 0, false);
    },
    handleVideoPlay(e) {
      let duration = e.target.duration;
      let interval = 10
      let that = this
      this.logTimer = setInterval(function(){
        let playbackRate =  (that.$refs.video&&that.$refs.video.playbackRate)?that.$refs.video.playbackRate:1
        that.studyLog(parseInt(duration), parseInt(interval * playbackRate), false);
      }, interval * 1000)
    },
    handleVideoPause() {
      console.log("pause");
      clearInterval(this.logTimer)
    },
    handleVideoEnded(e) {
      console.log("ended");
      let duration = e.target.duration;
      this.currentMedia.finished = true;
      clearInterval(this.logTimer)
      this.studyLog(parseInt(duration), 1, true);
    },
    handleVideoUpdate(e) {
      // console.log(e);
      
      // let rate = 10; //日志记录频率
      // let currentTime = e.target.currentTime;
      // let duration = e.target.duration;
      // this.cacheDuration += currentTime - this.lastPlayTime;
      // this.lastPlayTime = currentTime;
      // //播放10秒记录日志
      // if (this.cacheDuration > rate) {
      //   console.log("handleVideoUpdate", e);
      //   this.studyLog(parseInt(duration), parseInt(this.cacheDuration), false);
      //   this.cacheDuration = 0;
      // }
    },
    //记录学习日志
    studyLog(videoTime, duration, finished) {
      getAction(this.url.studyLog, {
        mediaId: this.mediaId,
        mediaType: this.currentMedia.mediaType,
        unitId: this.unitId,
        courseId: this.courseId,
        videoTime,
        duration,
        finished,
      }).then((res) => {});
    },
    getUnitStudyLog() {
      getAction(this.url.unitStudyLog, {
        courseId: this.currentMedia.courseId,
        unitId: this.unitId,
      });
    },
    handleViewCode(media) {
      switch (media.codeType) {
        case 1:
          window.open(
            "/scratch3/index.html?scene=twl&unitId=" +
              this.unitId +
              "&mediaId=" +
              media.mediaId +
              "&workName=" +
              media.mediaName
          );
          break;
        case 2:
          window.open(
            "/scratch3/index.html?scene=twl&unitId=" +
              this.unitId +
              "&mediaId=" +
              media.mediaId +
              "&workName=" +
              media.mediaName
          );
          break;
        case 3:
          return window.open(
            "/scratchjr/editor.html?mode=edit&filepath=" +
              this.currentMedia.mediaPath_url
          );
          break;
        case 4:
          return window.open(
            "/onlinecode/index.html?lang=turtle&unitId=" +
              this.unitId +
              "&mediaId=" +
              media.mediaId +
              "&workName=" +
              media.mediaName
          );
          break;
        case 5:
          return window.open(
            "/onlinecode/index.html?lang=python&unitId=" +
              this.unitId +
              "&mediaId=" +
              media.mediaId +
              "&workName=" +
              media.mediaName
          );
          break;
        case 6:
          return window.open(
            "/onlinecode/index.html?lang=c&unitId=" +
              this.unitId +
              "&mediaId=" +
              media.mediaId +
              "&workName=" +
              media.mediaName
          );
          break;
        case 7:
          return window.open(
            "/onlinecode/index.html?lang=cpp&unitId=" +
              this.unitId +
              "&mediaId=" +
              media.mediaId +
              "&workName=" +
              media.mediaName
          );
          break;
        case 8:
          return window.open(
            "/onlinecode/index.html?lang=java&unitId=" +
              this.unitId +
              "&mediaId=" +
              media.mediaId +
              "&workName=" +
              media.mediaName
          );
          break;
        default:
          window.open(this.getQiniuFile(media.mediaPath_url));
      }
    },
  },
};
</script>
<style lang="less" scoped>
.video-area {
  max-height: 700px;
  overflow: auto;
  video {
    width: 100%;
    height: 700px;
    // min-height: 500px;
  }
}
.unit-list {
  vertical-align: top;
  padding: 10px;
  margin: 0 20px;
  overflow-y: auto;
}
</style>
